import Api from "../../../../services/Api";

function fetchLogList(serialNumber, config = {}) {
  return Api.get(`/service/evse_management/api/v1/evse/${serialNumber}/ocpp_logs`, {}, config);
}

export { fetchLogList };
